module.exports = __webpack_public_path__ + "img/05.9f3f6fb6.jpg";